import { render, staticRenderFns } from "./TableObjectiveConfig.vue?vue&type=template&id=7180b405&scoped=true"
import script from "./TableObjectiveConfig.vue?vue&type=script&lang=js"
export * from "./TableObjectiveConfig.vue?vue&type=script&lang=js"
import style0 from "./TableObjectiveConfig.vue?vue&type=style&index=0&id=7180b405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180b405",
  null
  
)

export default component.exports